/**
 * StakeOfferDeclinedScreen.tsx
 * Stake offer declined screen
 */

import { type FC, useEffect } from 'react';

import { Button } from '@skillarea/lib-frontend';
import { Title, TextBlock } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from '../MatchmakingModal.module.scss';

const STAKE_DECLINE_PAUSE = 2000;

export interface IStakeOfferDeclinedScreenProps {
  onContinue: () => void;
}

export const StakeOfferDeclinedScreen: FC<IStakeOfferDeclinedScreenProps> = ({
  onContinue,
}) => {
  const { t } = useTranslation('matchmaking');

  useEffect(() => {
    const timer = setTimeout(onContinue, STAKE_DECLINE_PAUSE);
    return () => clearTimeout(timer);
  }, [onContinue]);

  return (
    <div className={styles.screen}>
      <div className={`${styles.centered} ${styles.resultScreen}`}>
        <div className={styles.resultIcon}>
          <span className={styles.emoji}>⚠️</span>
        </div>

        <TextBlock className={styles.resultText} size="l">
          {t('stake.entryFeeDeclinedMessage')}
        </TextBlock>

        <Title className={styles.resultTitle} color="contrast">
          {t('stake.entryFeeDeclined')}
        </Title>
      </div>

      <div className={styles.footer}>
        <div className={styles.actionButtons}>
          <Button
            className={styles.actionButton}
            color="accent"
            name={t('common.continue')}
            onClick={onContinue}
            size="s"
            variant="filled"
          >
            {t('common.continue')}
          </Button>
        </div>
      </div>
    </div>
  );
};
